/*
SESSION TYPES:
- presentation
  - presentation with author
- meta
  - other than presentations such as coffee break, etc.
  - for meta sessions without defined track will be populated cross session `track`
*/

const FIRST_DAY = '2018-03-03'
const SECOND_DAY = '2018-03-04'

const coffeeBreakImage = require('../resources/coffee-break.jpg')
const lunchAndDinnerImage = require('../resources/obed-vecera.jpg')
const yogaImage = require('../resources/yoga.jpg')
const discussionImage = require('../resources/discussion.jpg')

const coffeeBreak = {
  title: 'Coffee break',
  image: coffeeBreakImage,
  imageWidth: 560,
}

const lunch = {
  title: 'Oběd',
  image: lunchAndDinnerImage,
  imageWidth: 560,
}

const track1 = 'hall1'
const track2 = 'hall2'
const track1_wide = 'hall1Wide'
// TODO - encounter? what to do with workshops?
//const tracks1_2 = 'both'
const rest = 'restaurant'
const exh = 'exhibitors'

export default [
  // FIRST DAY
  {
    date: FIRST_DAY,
    time: '08:00',
    track: track1_wide,
    meta: {
      title: 'Registrace účastníků',
    },
  },
  {
    date: FIRST_DAY,
    time: '09:00',
    track: track1_wide,
    meta: {
      title: 'Zahájení konference',
    },
  },
  {
    date: FIRST_DAY,
    time: '09:15',
    track: track1,
    presentation: 'p07_mozek_jsme_my',
  },
  {
    date: FIRST_DAY,
    time: '10:10',
    track: track1,
    presentation: 'p03_vyvin_pohyb',
  },
  {
    date: FIRST_DAY,
    time: '10:10',
    track: track2,
    presentation: 'p10_v_ucitelskych_monterkach',
  },
  {
    date: FIRST_DAY,
    time: '11:00',
    track: exh,
    meta: coffeeBreak,
  },
  {
    date: FIRST_DAY,
    time: '11:30',
    track: track1,
    presentation: 'p06_koreny_zavislosti',
  },
  {
    date: FIRST_DAY,
    time: '11:30',
    track: track2,
    presentation: 'p09_co_jedia',
  },
  {
    date: FIRST_DAY,
    time: '12:15',
    track: rest,
    meta: lunch,
  },
  {
    date: FIRST_DAY,
    time: '13:30',
    track: track1,
    presentation: 'c01_encounter',
  },
  {
    date: FIRST_DAY,
    time: '13:30',
    track: track2,
    presentation: 'c03_workshops_sobota',
  },
  {
    date: FIRST_DAY,
    time: '15:30',
    track: exh,
    meta: coffeeBreak,
  },
  {
    date: FIRST_DAY,
    time: '16:00',
    track: track1,
    presentation: 'p04_o_odnimani_zodpovednosti',
  },
  {
    date: FIRST_DAY,
    time: '16:00',
    track: track2,
    presentation: 'c04_pecha_kucha',
  },
  {
    date: FIRST_DAY,
    time: '16:50',
    track: track1,
    presentation: 'p01_ako_ucit_dieta',
  },
  {
    date: FIRST_DAY,
    time: '18:00',
    track: rest,
    meta: {
      title: 'Večeře',
      image: lunchAndDinnerImage,
      imageWidth: 560,
    },
  },
  {
    date: FIRST_DAY,
    time: '19:00',
    endTime: '20:00',
    track: track2,
    meta: {
      title: 'Tématické diskuze',
      image: discussionImage,
      imageWidth: 560,
    },
  },
  // SECOND DAY
  {
    date: SECOND_DAY,
    time: '07:00',
    track: track2,
    meta: {
      title: 'Ranní jóga',
      image: yogaImage,
      imageWidth: 560,
    },
  },
  {
    date: SECOND_DAY,
    time: '09:00',
    track: track1,
    presentation: 'c02_panelova_diskusia',
  },
  {
    date: SECOND_DAY,
    time: '09:00',
    track: track2,
    presentation: 'p02_kroky_k_uspechu',
  },
  {
    date: SECOND_DAY,
    time: '10:00',
    track: track1,
    presentation: 'c02_panelova_diskusia',
  },
  {
    date: SECOND_DAY,
    time: '10:00',
    track: track2,
    presentation: 'p08_telo_a_mozek',
  },
  {
    date: SECOND_DAY,
    time: '10:30',
    track: exh,
    meta: coffeeBreak,
  },
  {
    date: SECOND_DAY,
    time: '11:00',
    track: track1,
    presentation: 'p05_zdrava_strava',
  },
  {
    date: SECOND_DAY,
    time: '12:00',
    track: rest,
    meta: lunch,
  },
  {
    date: SECOND_DAY,
    time: '13:00',
    track: track1,
    presentation: 'c01_encounter',
  },
  {
    date: SECOND_DAY,
    time: '13:00',
    track: track2,
    presentation: 'c05_workshops_nedela',
  },
  {
    date: SECOND_DAY,
    time: '15:00',
    track: track1_wide,
    meta: {
      title: 'Ukončení konference',
    },
  },
]



// WEBPACK FOOTER //
// ./src/content/devdata/data/sessions.js